import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';
import { signedChange } from '../components/payment-analytics/paymentCardData';

const formatValue = (value) => {
  if (value === null || value === undefined) return '0';
  if (typeof value === 'number') return value.toLocaleString();
  return value;
};

export const fetchPaymentAnalyticsStats = async (filter, paymentCardData, setData) => {
  const { dateRange, country, state, city, platforms, paymentUserFilter } = filter;

  const queryParams = buildQueryParams({
    dateRange,
    country,
    state,
    city,
    platforms,
    paymentUserFilter,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/payment/stats?${queryParams}`,
  });
  if (!res) return;
  if (res.status >= 200 && res.status < 300 && res.data) {
    if (Array.isArray(res.data.data) && res.data.data.length > 0) {
      const formattedData = res.data.data.map(item => ({
        ...item,
        value: formatValue(item.value),
        change: signedChange(item),
      }));
      setData(formattedData);
    }
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchPaymentTimeline = async (userId) => {
  if (!userId) return null;
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/payment/timeline/${userId}`,
  });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data || null;
  }
  throw new Error(`Unexpected response code: ${res.status}`);
};

export const fetchPaymentAnalyticsList = async ({
  filter,
  setData,
  page,
  limit,
  searchTerm,
  sortBy,
  sortOrder,
  funnelType,
  action,
}) => {
  const { dateRange, country, state, city, platforms, paymentUserFilter } = filter;

  const queryParams = buildQueryParams({
    dateRange,
    country,
    state,
    city,
    platforms,
    paymentUserFilter,
    page,
    limit,
    searchTerm,
    sortBy,
    sortOrder,
    funnelType,
    action,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/payment/list?${queryParams}`,
  });
  if (!res) return;
  if (res.status >= 200 && res.status < 300 && res.data) {
    const payload = res.data;
    setData(Array.isArray(payload.data) ? payload.data : []);
    return {
      totalRecords: payload.pagination?.totalRecords || 0,
      totalPages: payload.pagination?.totalPages || 0,
    };
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
